import { graphql } from "@opensea/graphql"

export const CurrencyLinksFragment = graphql(
  `
    fragment CurrencyLinks on Currency {
      contractAddress
      socials {
        website
        twitterHandle
        telegramIdentifier
      }
      chain {
        identifier
      }
      metadata {
        fullCollection {
          twitterUsername
          discordUrl
          externalUrl
          instagramUsername
          mediumUsername
          telegramUrl
          wikiUrl
        }
      }
    }
  `,
  [],
)
